<form autocomplete="off" [formGroup]="RiskProfileForm">
    <div class="row NewDesign">
        <div class="RiskOuter RiskCardsWrap" [ngClass]="!IsMobile ? 'col-12':'col-7'">
            <label *ngFor="let profile of RiskProfileList" class="RiskCard Risk_{{profile.VALUEFIELD}}"
                for="profile-{{profile.VALUEFIELD}}">
                <input type="radio" class="RiskRadio" [value]="profile.VALUEFIELD" name="RiskProfile"
                    formControlName="RiskProfile" id="profile-{{profile.VALUEFIELD}}"
                    [ngClass]="{'is-invalid': RiskProfileFormSubmitted && RP.RiskProfile.errors}" />
                <span class="RiskCardInner">
                    <span class="RiskIcon">
                        <svg *ngIf="profile.VALUEFIELD == 1" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" />
                            <path d="M9 12l2 2 4-4" />
                        </svg>
                        <svg *ngIf="profile.VALUEFIELD == 2" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 3v18M7 21h10M6 7l-3 6a3 3 0 0 0 6 0L6 7zM18 7l-3 6a3 3 0 0 0 6 0l-3-6zM4 7h16" />
                        </svg>
                        <svg *ngIf="profile.VALUEFIELD == 3" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M5 15c-1 1-1.5 4-1.5 4s3-.5 4-1.5" />
                            <path d="M15 5c3-1 5 1 4 4-1 4-6 8-9 9l-4-4c1-3 5-8 9-9z" />
                            <circle cx="14.5" cy="9.5" r="1.5" />
                        </svg>
                    </span>
                    <span class="RiskBody">
                        <span class="RiskName">
                            {{ profile.TEXTFIELD }}
                            <img src="../../../assets/images/IIFL_New_Icons/info-circle-fill.svg"
                                [tooltip]="profile.RiskProfile" container="body" tooltip-class="CommonTooltip" />
                        </span>
                        <span class="RiskDesc">{{ profile.RiskProfile }}</span>
                    </span>
                    <span class="RiskDot"></span>
                </span>
            </label>
        </div>
        <div *ngIf="RiskProfileFormSubmitted && RP.RiskProfile.errors" class="d-block invalid-feedback col-12">
            <div *ngIf="RP.RiskProfile.errors.required">
                Risk profile is required.
            </div>
        </div>
    </div>
    <div class="row" *ngIf="this.G_UserType == 3">
        <div class="col-12" *ngIf="IsSB_EMP_RiskProfileDiv">
                <p>Your risk profile with us was updated as <b>{{ SB_EMP_RiskProfile }}</b>. Your MA / RM has initiated this change and updated it as <b>{{RiskProfileName}}</b>. Please approve to update the same.</p>
        </div>
        <div class="col-12">
            <div class="CheckAgree TandC">
                <div class="checkbox-wrapper"> <label class="Cbx_container">
                        <input type="checkbox" (change)="CheckTerms($event)" formControlName="TAndC" />
                        <span class="checkmark"></span>
                        <label>
                            <span>I/we hereby agree with <a class="BlueText"
                                    (click)="CallTermsAndConditionsModal()">Terms &
                                    Conditions.</a>
                            </span>
                        </label>
                    </label>
                </div>
            </div>
            <div *ngIf="RiskProfileFormSubmitted && RP.TAndC.errors" class="d-block invalid-feedback">
                <div *ngIf="RP.TAndC.errors.required">
                    Please accept Terms & Conditions.
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center" *ngIf="!isButtonSkipConfirmEnabled">
            <button class="CommonSubmitButton mt-4 w-25" (click)="onSubmitRiskProfile()" [disabled]="(G_UserType === 3 && !CheckIINTerms) || (G_UserType ==2 && showBtn) ||(G_UserType ==1 && showBtn)">
                {{SaveBtnText}}
            </button>
        </div>
        <div class="col-12 RiskBtnRow" *ngIf="isButtonSkipConfirmEnabled">
            <button class="CommonSubmitButton" (click)="onSubmitRiskProfile()" [disabled]="(G_UserType === 3 && !CheckIINTerms) || (G_UserType ==2 && showBtn) || (G_UserType == 1 && showBtn)">
                {{SaveBtnText}}
            </button>
            <button class="RiskBtnGhost" (click)="onSkipRiskProfile()" *ngIf="ShowSkipBtn">
                Skip
            </button>
        </div>
    </div>
</form>
<div class="modal" id="TermsAndConditionsModal" appDisabledRightClick>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content AlertModalContentCls">
            <div class="modal-header AlertModalHeader">Terms & Conditions
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" routerLinkActive="active">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div id="TermsAndConditionsModalContent" class="modal-body DowntimeAlertModalBody">
                • I further acknowledge that the Risk Profile is for understanding personal risk tolerance and serve
                only as a reference for consideration for making my own investment decisions and should not be construed
                as Investment advice.
                <br />
                • I acknowledge that Incred Markets Limited is not carrying out any product suitability assessment or
                providing any mutual fund product recommendation or advice.
                <br />
                • I also acknowledge that the decision to select and invest in mutual fund products made available by
                Incred Markets Limited will finally and solely rest with me and it does not entail any investment advice
                from Incred Markets Limited.
                <br />
                • You can align your mutual fund risk profile for effective financial planning based on your own risk
                appetite. Incred Markets Limited do not promise that the investments you make based on any of the plans
                will be profitable. The investments are subject to various market, currency, economic, political and
                business risks.
                <br />
                • I/We have fully read and understood the contents of the Scheme Information Document and Key
                Information Memorandum including addenda thereto with respect to the Mutual Fund scheme (“the Scheme”)
                subscribed herein and hereby confirm and agree to abide by the terms and conditions for placing an order
                on the Mutual Fund platform offered by Incred Markets Limited.
                <br />
                • These terms and conditions will always be read and construed in conjunction with the mandatory rights
                and obligations (including non-mandatory obligations, if any) entered between MFI and me/us.
            </div>
            <div class="modal-footer AlertModalFooter">
                <!-- <button type="button" data-dismiss="modal" class="CursorPointer">/button> -->
            </div>
        </div>
    </div>
</div>
<div class="modal" id="AlertModal" appDisabledRightClick>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content AlertModalContentCls">
            <div class="modal-header AlertModalHeader">Important Message
            </div>
            <div id="AlertModalContent" class="modal-body AlertModalBody"></div>
            <div class="modal-footer AlertModalFooter">
                <button type="button" data-dismiss="modal" class="CursorPointer" (click)="RefreshPage()">Okay</button>
            </div>
        </div>
    </div>
</div>